import Axios from '../../library/Axios'

export const BlogPostsAction = (page: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'BLOG_POSTS_REQUEST' })

        const { data } = await new Axios().get(`/get/blog/${page}`)

        dispatch({ type: 'BLOG_POSTS_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'BLOG_POSTS_ERROR' })
    }
}

export const BlogViewAction = (id: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'BLOG_VIEW_REQUEST' })

        const { data } = await new Axios().get(`/get/blog_view/${id}`)

        dispatch({ type: 'BLOG_VIEW_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'BLOG_VIEW_ERROR' })
    }
}

export const BlogCommentsAction = (id: string, page: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'BLOG_COMMENTS_REQUEST' })

        const { data } = await new Axios().get(`/get/blog/${id}/comments/${page}`)

        dispatch({ type: 'BLOG_COMMENTS_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'BLOG_COMMENTS_ERROR' })
    }
}